import React from 'react';

import {Box, Stack, Skeleton, Divider} from 'views/components';

import LargeSkeleton from './LargeSkeleton';

const SkeletonComponent = () => {
  return (
    <Box height={'100%'}>
      <Stack direction={'row'} spacing={1} sx={{mb: 1}}>
        <Skeleton variant="circular" height={40} width={40}/>
        <Skeleton variant="text" height={40} width={'40%'}/>
      </Stack>
      <Divider />
      <Stack height={'350px'} sx={{py: 1}}>
        <LargeSkeleton />
      </Stack>
      <Skeleton variant="rounded" height={40} width={'100%%'}/>
    </Box>
  );
};


export default React.memo(SkeletonComponent);
